import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["note", "hideResolvedNotes"];

  declare hideResolvedNotesTarget: HTMLInputElement;
  declare noteTargets: HTMLElement[];

  connect() {
    window.addEventListener("turbo:morph", this.morph);
    this.morph();
  }

  disconnect() {
    window.removeEventListener("turbo:morph", this.morph);
  }

  morph() {
    const textarea = document.getElementById("shift_report_general_notes");
    if (textarea) {
      textarea.addEventListener("input", () => {
        // set to 1px so the textarea properly resizes when the height reduces
        textarea.style.height = "1px";
        textarea.style.height = textarea.scrollHeight + "px";
      })
      textarea.dispatchEvent(new Event("input"));
    }
  }

  updateResolvedNotesDisplay() {
    this.noteTargets.forEach((el) => {
      if (this.hideResolvedNotesTarget.checked && el.classList.contains("resolved")) {
        el.classList.add("is-hidden");
      } else {
        el.classList.remove("is-hidden");
      }
    });
  }

  noteTargetConnected(element: HTMLElement) {
    if (element.classList.contains("resolved") && this.hideResolvedNotesTarget.checked) {
      element.classList.add("is-hidden");
    }
  }
}
